import angular from "angular";

angular
    .module('app')
    .component('coursePage', {
        template: require('./course-page.html'),
        controller: ['$http', '$uibModal', 'Auth', '$rootScope', 'Notifier', '$q', 'trans','$timeout', controller],
        bindings: {
            course: '<',
            paymentStatus: '@',
            paymentType: '@',
            chapters: '<',
            reviews: '<',
            groups: '<',
            lessonsCount: '<',
            courseStatus: '@',
        }
    });

function controller($http, $uibModal, Auth, $rootScope, Notifier, $q, trans,$timeout) {

    let $ctrl = this;

    $ctrl.existsChecked = false;

    $rootScope.$on('UserLoginFromHeader', function (event, data) {
        $ctrl.user = data.user;
        checkCourseStatus();
    });

    $ctrl.$onInit = function () {

        $ctrl.user = Auth.user();
        if ($ctrl.paymentStatus) {
            alertPaymentStatus();
        }
    };

    $ctrl.writeMessage = () => {
        window.open('https://wa.me/'+$ctrl.course.phone);
    }

    function alertPaymentStatus() {
        if ($ctrl.paymentStatus == 'success') {
            window.Swal.fire({
                icon: 'success',
                title: trans('Payment is success'),
            });

            if ($ctrl.paymentType == 'individual'){
                $timeout(function () {
                    window.location = `/cabinet/courses/${$ctrl.course.id}`
                }, 3000);
            }
        }

        if ($ctrl.paymentStatus == 'fail') {
            window.Swal.fire({
                icon: 'error',
                title: trans('Payment not success'),
            });
        }
    }

    $ctrl.checkout = function (type, group) {

        if (!$ctrl.courseStatus ||  $ctrl.courseStatus == 'demo' || $ctrl.courseStatus == 'closed') {

            if ($ctrl.user) {
                checkCourseStatus().then(function () {
                    if (!$ctrl.courseStatus ||  $ctrl.courseStatus == 'demo' || $ctrl.courseStatus == 'closed') {
                        openCheckoutModal(type, group);
                    }
                });
            } else {
                Auth
                    .openLoginModal()
                    .then(
                        function (user) {
                            $ctrl.user = user;
                            $rootScope.$emit('UserLoginFromCoursePage', {user});
                            checkCourseStatus().then(function () {
                                if (!$ctrl.courseStatus ||  $ctrl.courseStatus == 'demo' || $ctrl.courseStatus == 'closed') {
                                    openCheckoutModal(type, group);
                                }
                            });
                        }
                    );
            }
        }
    };

    function openCheckoutModal(type, group) {

        let cost = type == 'group' ? (group.discount_value ? group.discount_value : group.cost) :
            ($ctrl.course.discount_value ? $ctrl.course.discount_value : $ctrl.course.cost);


        if (cost && type != 'demo') {
            $uibModal.open({
                component: 'courseBuyConfirm',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    type: function () {
                        return type;
                    },
                    group: function () {
                        return group;
                    }

                },
            });
        }

        if (!cost && type != 'demo') {
            $uibModal.open({
                component: 'freeSignUp',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    type: function () {
                        return type;
                    },
                    group: function () {
                        return group;
                    }
                }
            }).result.then(
                function () {
                    $ctrl.courseStatus = 'active';
                }
            )
        }
        if (type == 'demo'){
            $ctrl.demoCheckout();
        }
    }

    function checkCourseStatus() {

        let defer = $q.defer();

        $ctrl.courseStatusLoading = true;

        $http
            .get(`/courses/${$ctrl.course.id}/check-for-exists`)
            .then(
                function (response) {
                    $ctrl.courseStatusLoading = false;
                    let status = response.data.status;
                    $ctrl.courseStatus = status;
                    defer.resolve();
                },
                function (error) {
                    Notifier.error(trans("Error checking course status"));
                    $ctrl.courseStatusLoading = false;
                    defer.reject();
                }
            );

        return defer.promise;
    }

    $ctrl.openPreviewVideo = function () {
        $uibModal
            .open({
                component: 'courseVideoPreview',
                size: 'lg',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (res) {
                },
                function (error) {
                }
            );
    };

    $ctrl.demoCheckout = function () {
        $uibModal
            .open({
                component: 'demoSignUp',
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    }
                }
            })
            .result
            .then(
                function (response) {
                    $ctrl.courseStatus = 'demo';

                },
                function () {

                }
            );
    };
}
